var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailAllFollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H3a.5.5 0 01-.5-.5v-11A.5.5 0 013 2h10a.5.5 0 01.5.5V8M5 5h6M5 8h3",
    stroke: "#6F7485",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.094l1.667 1.75 3.333-3.5",
    stroke: "#6F7485",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTRIM0MyLjcyMzg2IDE0IDIuNSAxMy43NzYxIDIuNSAxMy41VjIuNUMyLjUgMi4yMjM4NiAyLjcyMzg2IDIgMyAySDEzQzEzLjI3NjEgMiAxMy41IDIuMjIzODYgMTMuNSAyLjVWOCIgc3Ryb2tlPSIjNkY3NDg1IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTUgNUgxMSIgc3Ryb2tlPSIjNkY3NDg1IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTUgOEg4IiBzdHJva2U9IiM2Rjc0ODUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTAgMTIuMDkzN0wxMS42NjY3IDEzLjg0MzdMMTUgMTAuMzQzOCIgc3Ryb2tlPSIjNkY3NDg1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgMailAllFollow as ReactComponent };